import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import AuthService from "../AuthService";

class Authenticate extends Component {
    componentDidMount() {
        if (!AuthService.getToken()) {
            this.props.history.push('/admin');
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.props.children}
            </React.Fragment>
        );
    }
}

export default withRouter(Authenticate);
